import styled from "styled-components";
import {colorPalette} from "../../../../../../styles/colorPalette";
import {baseDistance, fontSize, fontWeight, VerticalFlexStyle} from "../../../../../../styles/styles";
import {TabViewButtonContainerStyled} from "../../../../../../widgets/tab/TabViewV5";
import {InfoButtonStyled} from "../../../../../../button/InfoButtonV5";
import {ToggleSwitchFieldStyled} from "../../../../../../details/ToggleSwitchFieldV5";

export const ReportColumnsStyled = styled.div`
	${VerticalFlexStyle};
	width: 100%;
	max-width: 864px;
	min-height: 0;

	${ToggleSwitchFieldStyled} + ${InfoButtonStyled} {
		top: 0;
		color: ${colorPalette.blueGray.c700Dark};
		height: ${baseDistance.md};

		svg {
			width: 16px;
			height: 16px;
		}
	}

	.ColumnEditor {
		.manage-cols-box {
			.col {
				.name {
					font-size: ${fontSize.md};
				}

				&.left {
					border-right: 1px solid ${colorPalette.gray.c300};
					background-color: ${colorPalette.gray.c100};

					${TabViewButtonContainerStyled} {
						.button {
							color: ${colorPalette.gray.c950};
							border-bottom: solid 2px transparent;
							padding-top: ${baseDistance.xxs};

							&.selected:not(:only-child) {
								color: ${colorPalette.primary.c500Primary};
								border-bottom-color: ${colorPalette.primary.c500Primary};
							}

							.tabLabel {
								font-size: ${fontSize.md};
								line-height: 18px;
							}
						}
					}
				}

				.border {
					.views {
						.DetailsContent {
							padding: 0;
						}
					}

					.buttons {
						padding: 0;

						.tabLabel {
							font-size: ${fontSize.lg};
							font-weight: ${fontWeight.normal};
						}
					}
				}
			}
		}
	}

	.toggleSwitchLabel {
		display: none;
	}

	.ToggleSwitchField {
		.label {
			padding: ${baseDistance.sm} 0 ${baseDistance.sm} ${baseDistance.md};
			color: black;
		}
	}
`;
